import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Onboarding>\n  <BvSpinner/>\n</Onboarding>")